'use strict';

intellidealerAppCoreModule.factory('logoutResource', function ($resource, appConfigurationService) {
  return $resource(appConfigurationService.basePath + '/logout');
});
